import instance, { ApiResponse } from '../../api';
import { AxiosResponse } from 'axios';
import { BaseApi } from '../../baseApi';
import { endpoints } from '../../endpoints.config';

export class DropdownLinksApi extends BaseApi {
    public static getDropdownLinks = async (): Promise<any> => {
        try {
            const result: AxiosResponse<ApiResponse<any>> = await instance.get(
                endpoints.dashboard.availablePages
            );
            if(DropdownLinksApi.isResponseSuccessful(result.data)){
                const data = result.data.details;
                return DropdownLinksApi.successResponse(data);
            }
        } catch (error: any) {
            if (error.response){
                const errors = error.response.data.errors;

                if (errors){
                    return DropdownLinksApi.errorResponse(errors);
                }
            }
        }
    };
}